import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {AuthService} from '../../../../../core/service/auth.service';
import {VnaPortalService} from '../../services/vna-portal.service';
import {ModalExtended} from 'ngx-dynamic-modal';
import {AlertaService} from '../../../../../shared/services/alerta.service';

@Component({
  selector: 'app-service-to-portal',
  templateUrl: './service-to-portal.component.html',
  styleUrls: ['./service-to-portal.component.scss']
})
export class ServiceToPortalComponent extends ModalExtended implements OnInit {

    availableServices: Array<Object> = [];
    loading: boolean = false;

    formData: FormGroup;
    data: Object;

    constructor(private fb: FormBuilder, private auth: AuthService, private portalService: VnaPortalService, private alertService: AlertaService) {
        super();

        this.formData = this.fb.group({
            'service_pk' : new FormControl('', Validators.required),
            'active' : new FormControl('0'),
        });
    }

    addServiceToPortal(): void {
        this.loading = true;
        const data = Object.assign({ 'config_portal' : { 'config' : {}, 'auth' : {} } }, this.formData.value);

        this
            .portalService
            .addServiceToPortal(this.auth.getPkPortal(), data)
            .subscribe(
                (r) => {
                    this.alertService.addAlert('success', 'Service added to portal successfully');
                    this.loading = false;
                }
            )
    }

    ngOnInit() {
        this.loading = true;
        this
            .portalService
            .getPortalPendingServices(this.auth.getPkPortal())
            .subscribe(
                (r) => {
                    this.availableServices = r;
                    this.loading = false;
                }
            )
    }

    onExit(data) {
        this.applyCallback(data);
        this.close();
    }

}



// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/config/vna_portal/modals/service-to-portal/service-to-portal.component.ts